module.exports = __webpack_public_path__ + "src/assets/img/rns.9759104e.jpg";